<template>

</template>

<script>

import OrganizationApi from '@/api/Organization.js'

export default {
  mounted () {
    let api = new OrganizationApi()
    let organization_id = this.$store.state.current_user.organization_id
    api.projects_crm_sync(organization_id).then((data) => {
      this.$store.commit('SET_NOTIFICATION', {
        'title': 'models.organizations.successfully_started_crm_sync',
        'type': 'success'
      })
      this.$router.go(-1)
    })
  }
}

</script>



// WEBPACK FOOTER //
// ProjectsSynchronize.vue?1bb24b18